import { createStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) =>
  createStyles({
    payBtnWrapper: {
      "& button": {
        cursor: "pointer",
        display: "inline-block",
        "-webkit-appearance": "-apple-pay-button",
        width: "100%",
        height: "54px",
        borderRadius: "30px",

        [theme.breakpoints.up('md')]: {
          height: '44px',
        },
        "&.plain": {
          '-apple-pay-button-type': "plain",
        },

        "&.setup": {
          '-apple-pay-button-type': "set-up"
        }
      }
    }
  })
);
